export const ARCHE_ID = 'arche_calendar';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;
